import { render, staticRenderFns } from "./CRDocCreationStatus.vue?vue&type=template&id=46311e6d&scoped=true"
import script from "./CRDocCreationStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./CRDocCreationStatus.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CRDocCreationStatus.vue?vue&type=style&index=0&id=46311e6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46311e6d",
  null
  
)

export default component.exports